import { render, staticRenderFns } from "./index_dp.vue?vue&type=template&id=030d5dbb&scoped=true"
import script from "./index_dp.vue?vue&type=script&lang=js"
export * from "./index_dp.vue?vue&type=script&lang=js"
import style0 from "./index_dp.vue?vue&type=style&index=0&id=030d5dbb&prod&scoped=true&lang=scss"
import style1 from "./index_dp.vue?vue&type=style&index=1&id=030d5dbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d5dbb",
  null
  
)

/* custom blocks */
import block0 from "./index_dp.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports